<template>
    <div class="container-fluid container-formulario">
        <div class=" linha-1">
            <div class="d-lg-flex d-flex-column">
                <div>
                    <div class="d-flex">
                        <img :src="evento.urlLogoThumb" class="rounded evento" title="Grupo Negócios Públicos" v-if="evento.urlLogoThumb != null">
                    </div>
                    <div class="card painel">
                        <div class="card-body">
                            <h4 class="card-title d-flex titulo">Evento</h4>
                            <h4 class="card-title d-flex titulo2">{{ evento.nmEvento }}</h4>
                            <div class="card-text">
                                <strong class="d-inline-flex titulo">Data &amp; Local:</strong>
                                <div class="d-flex texto-1">{{ formatDay(evento.dtInicio) }} a {{ formatDay(evento.dtFim) }} de {{ formatMonth(evento.dtInicio) }} de {{ formatYear(evento.dtInicio) }}</div>
                                <div class="d-flex texto-2">{{ evento.dsLocal }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card painel-2 d-flex">
                        <div class="card-text">
                            <div class="texto-1">
                                <div class="col-md-12">
                                    <h4 class="titulo2">Dados da Inscrição</h4>
                                    <div class="font-5">
                                        <label>Localizador:</label>
                                        <p class="font-6" id="txt_CpfCnpj">{{ inscricao.cdLocalizador }}</p>
                                    </div>
                                    <div class="font-5">
                                        <label id="lbl_tpContato">E-MAIL:</label>
                                        <p class="font-6" id="txt_Email" v-if="autenticar">********@******</p>
                                        <p class="font-6" id="txt_Email" v-else>{{ inscricao.dsEmailResponsavel }}</p>
                                    </div>
                                    <div class="font-5">
                                        <label>CPF/CNPJ:</label>
                                        <p class="font-6" id="txt_CpfCnpj">***.***.***-**</p>
                                    </div>
                                    <div class="font-5">
                                        <label>INSTITUIÇÃO/NOME:</label>
                                        <p class="font-6" id="txt_Nome">{{ inscricao.nmNome }}</p>
                                    </div>
                                    <div class="font-5">
                                        <label>TELEFONE:</label>
                                        <p class="font-6" id="txt_Telefone">(**) ****-****</p>
                                    </div>
                                    <div class="font-5">
                                        <label>CELULAR:</label>
                                        <p class="font-6" id="txt_Celular">(**) *****-****</p>
                                    </div>
                                    <div class="font-5">
                                        <label>CEP:</label>
                                        <p class="font-6" id="txt_Cep">{{ inscricao.dsCep }}</p>
                                    </div>
                                    <div class="font-5">
                                        <label>ENDEREÇO:</label>
                                        <p class="font-6" id="txt_Endereco">{{ inscricao.dsEndereco }}</p>
                                    </div>
                                    <div class="font-5">
                                        <label>NÚMERO:</label>
                                        <p class="font-6" id="txt_Numero">***</p>
                                    </div>
                                    <div class="font-5">
                                        <label>COMPLEMENTO:</label>
                                        <p class="font-6" id="txt_Complemento"></p>
                                    </div>
                                    <div class="font-5">
                                        <label>BAIRRO:</label>
                                        <p class="font-6" id="txt_Bairro">********</p>
                                    </div>
                                    <div class="font-5">
                                        <label>CIDADE:</label>
                                        <p class="font-6" id="txt_Cidade">{{ inscricao.nmCidade }}</p>
                                    </div>
                                    <div class="font-5">
                                        <label>ESTADO:</label>
                                        <p class="font-6" id="txt_Estado">{{ inscricao.nmUf }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-fill conteudo" v-if="autenticar && acesso.flLiberaPin == false">
                    <div class="card painel-3">
                        <div class="card-body card-body2">
                            <div class="row">
                                <div class="col-12 pt-1 ps-5 pe-5">
                                    <img src="../../assets/img/logo_np.png" class="logo ms-3 mt-3" title="Grupo Negócios Públicos">
                                    <h2 class="formularios mt-4">Para acessar o cadastro de participantes use o e-mail do responsavel</h2>
                                    <label for="email" class="pb-1 font-1">E-mail</label>
                                    <span class="field-validation-valid labelValidacao"></span>
                                    <div class="input-group">
                                        <input type="email" class="form-control informacao2" v-model="acesso.dsEmailResponsavel">
                                        <div class="card">
                                            <span class="input-group-btn"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="footer-2">
                                    <div class="col-sm-12 col-lg-12">
                                        <button class="btn btn-success float-end rounded mb-3 me-4" v-on:click="solicitar_acesso">SOLICITAR ACESSO</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-fill conteudo" v-else-if="acesso.flLiberaPin == true">
                    <div class="card painel-3">
                        <div class="card-body card-body2">
                            <div class="row">
                                <div class="col-12 pt-1 ps-5 pe-5">
                                    <img src="../../assets/img/logo_np.png" class="logo ms-3" title="Grupo Negócios Públicos">
                                    <h2 class="formularios">Enviamos um código para o seu e-mail. Digite-o para acessar.</h2>
                                    <label for="pin" class="pb-1 font-1">Codigo de Confirmação</label>
                                    <span class="field-validation-valid labelValidacao"></span>
                                    <div class="input-group">
                                        <input type="text" class="form-control informacao2" v-model="acesso.nrPin">
                                    </div>
                                </div>
                                <div class="footer-2">
                                    <div class="col-sm-12 col-lg-12">
                                        <button class="btn btn-success float-end rounded mb-3 me-4" v-on:click="confirmar_pin">CONFIRMAR PIN</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-fill conteudo" v-else>
                    <div class="col">
                        <img src="../../assets/img/logo_np.png" class="logo ms-3" title="Grupo Negócios Públicos">
                        <button v-if="!autenticar" class="btn btn-danger btn-inscricao ms-3 float-end mt-0 mb-0 rounded" v-on:click="imprimir_inscricao"><i class="fas fa-print icon-inscricao"></i>Imprimir Inscrição</button>
                        <!--<button class="btn btn-danger btn-inscricao float-end mt-0 mb-0 rounded"><i class="fas fa-paper-plane icon-inscricao"></i>Solicitar Preenchimento</button>-->
                        <h2 class="formularios mt-4">Cadastro de Participantes ( {{ participantes.length }} / {{ inscricao.qtdParticipantes}} )</h2>
                    </div>

                    <div v-if="inscricao.qtdParticipantes > participantes.length">
                        <!--v-for="(value, index) in (inscricao.qtdParticipantes - participantes.length)" :key="index"-->
                        <div>
                            <div class="row linha-2 mt-4" style="margin-bottom: -30px;">
                                Participante
                            </div>
                            <div class="card painel-3">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-12 col-lg-6 pt-1">
                                            <label for="email" class="pb-1 font-1">E-mail *</label>
                                            <span class="field-validation-valid labelValidacao"></span>
                                            <input type="email" class="form-control informacao2" id="email" v-model="participante_crud.dsEmail">
                                        </div>
                                        <div class="col-sm-12 col-lg-6">
                                            <label for="confirm_email" class="pb-1 pt-2 font-1">Confirme o Email  *</label>
                                            <span class="field-validation-valid labelValidacao"></span>
                                            <input type="email" class="form-control informacao" id="confirm_email" name="confirm_email" v-model="participante_crud.dsEmailConfirma">
                                        </div>
                                        <div class="col-sm-12 col-lg-6">
                                            <label for="nome_completo" class="pb-1 pt-3 font-1">Nome Completo  *</label>
                                            <span class="labelValidacao field-validation-valid"></span>
                                            <input class="form-control valid informacao" type="text" id="nome_completo" name="nome_completo" v-model="participante_crud.nmParticipante">
                                        </div>
                                        <div class="col-sm-12 col-lg-3">
                                            <label for="nm_cracha" class="pb-1 pt-3 font-1">Nome Crachá  *</label>
                                            <span class="labelValidacao field-validation-valid"></span>
                                            <input class="form-control valid informacao" type="text" id="nm_cracha" name="nm_cracha" v-model="participante_crud.nmApelido">
                                        </div>
                                        <div class="col-sm-12 col-lg-3">
                                            <label for="sexo" class="pb-1 pt-3 font-1">Sexo  *</label>
                                            <select class="form-control informacao form-select" id="sexo" v-model="participante_crud.tpSexo">
                                                <option value="">Selecione</option>
                                                <option value="M">Masculino</option>
                                                <option value="F">Feminino</option>
                                                <option value="O">Outro</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-12 col-lg-3">
                                            <label for="cpf" class="pb-1 pt-3 font-1">Cpf *</label>
                                            <span class="field-validation-valid labelValidacao"></span>
                                            <input class="form-control informacao" type="text" id="cpf" v-maska="'###.###.###-##'" v-model="participante_crud.nrCpf">
                                        </div>
                                        <div class="col-lg-3">
                                            <label for="rg" class="pb-1 pt-3 font-1">Rg</label>
                                            <span class="field-validation-valid labelValidacao"></span>
                                            <input class="form-control informacao" type="text" id="rg" v-model="participante_crud.nrRg">
                                        </div>
                                        <div class="col-sm-12 col-lg-3">
                                            <label for="celular" class="pb-1 pt-3 font-1">Celular *</label>
                                            <span class="field-validation-valid labelValidacao"></span>
                                            <input class="form-control informacao" type="text" id="celular" v-maska="'(##) #####-####'" v-model="participante_crud.nrCelular">
                                        </div>
                                        <div class="col-sm-12 col-lg-3">
                                            <label for="dt_nascimento" class="pb-1 pt-3 font-1">Data de Nascimento *</label>
                                            <span class="field-validation-valid labelValidacao"></span>
                                            <input class="form-control informacao" type="text" id="dt_nascimento" v-maska="'##/##/####'" v-model="participante_crud.dtNascimento">
                                        </div>
                                        <div class="col-sm-12 col-lg-4">
                                            <label for="departamento" class="pb-1 pt-3 font-1">Departamento *</label>
                                            <select class="form-control form-select informacao" id="departamento" v-model="participante_crud.idDepartamento">
                                                <option value="0">Selecione</option>
                                                <option value="3">Administrativo</option>
                                                <option value="87">Agricultura</option>
                                                <option value="34">Arquitetura</option>
                                                <option value="89">Arrecadação</option>
                                                <option value="23">Assistência Social</option>
                                                <option value="79">Associado do IRIB</option>
                                                <option value="12">Auditoria</option>
                                                <option value="17">Biblioteca</option>
                                                <option value="69">Cadastro</option>
                                                <option value="18">Cadastro de Fornecedores</option>
                                                <option value="91">Coletoria</option>
                                                <option value="40">Comissão de Processo Administrativo Disciplinar</option>
                                                <option value="95">Comissão de Regularização Fundiária</option>
                                                <option value="21">Compras</option>
                                                <option value="10">Comunicação/Cerimonial/Eventos</option>
                                                <option value="4">Contabilidade</option>
                                                <option value="5">Contratos/Convênios</option>
                                                <option value="7">Controladoria</option>
                                                <option value="28">Controle Interno</option>
                                                <option value="36">Convênios</option>
                                                <option value="44">Corregedoria</option>
                                                <option value="68">Desapropriação</option>
                                                <option value="46">Desenvolvimento Social</option>
                                                <option value="48">Desenvolvimento Urbano</option>
                                                <option value="16">Direção</option>
                                                <option value="24">Educação</option>
                                                <option value="32">Engenharia</option>
                                                <option value="11">Engenharia</option>
                                                <option value="8">Financeiro</option>
                                                <option value="25">Gabinete</option>
                                                <option value="93">Gestao de pessoas</option>
                                                <option value="38">Gestão Estratégica</option>
                                                <option value="20">Governança</option>
                                                <option value="50">Habitação Social</option>
                                                <option value="35">Infraestrutura</option>
                                                <option value="1">Jurídico</option>
                                                <option value="77">LGPD</option>
                                                <option value="2">Licitação</option>
                                                <option value="15">Logística/Serviços Gerais</option>
                                                <option value="31">Manutenção Predial</option>
                                                <option value="9">Material/Almoxarifado/Patrimônio</option>
                                                <option value="52">Meio Ambiente</option>
                                                <option value="54">Mobilidade Urbana</option>
                                                <option value="81">Núcleo Sustentabilidade</option>
                                                <option value="33">Obras</option>
                                                <option value="73">Orçamento de Obras</option>
                                                <option value="27">Outro</option>
                                                <option value="75">Ouvidoria</option>
                                                <option value="97">Parcelamento&nbsp;de&nbsp;Solo</option>
                                                <option value="67">Patrimônio</option>
                                                <option value="14">Planejamento</option>
                                                <option value="66">Plano Diretor</option>
                                                <option value="83">PRESIDENCIA</option>
                                                <option value="26">Procuradoria</option>
                                                <option value="19">Projetos</option>
                                                <option value="39">Projetos em Bim</option>
                                                <option value="65">Regulação Urbano</option>
                                                <option value="56">Regularização Fundiária</option>
                                                <option value="6">Rh/Pessoas/Capacitação</option>
                                                <option value="70">Saneamento</option>
                                                <option value="22">Saúde</option>
                                                <option value="64">Secretaria de Administração</option>
                                                <option value="63">Secretaria de Governo</option>
                                                <option value="72">Setor de Recursos Humanos</option>
                                                <option value="71">Setor de Treinamento</option>
                                                <option value="58">Setor de Tributos</option>
                                                <option value="62">Social</option>
                                                <option value="85">suprimentos</option>
                                                <option value="37">Terceirização</option>
                                                <option value="42">Tesouraria</option>
                                                <option value="13">Ti</option>
                                                <option value="60">Urbanismo</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-12 col-lg-4">
                                            <label for="funcao" class="pb-1 pt-3 font-1">Função *</label>
                                            <select class="form-control informacao form-select" id="funcao" v-model="participante_crud.idFuncao">
                                                <option value="0">Selecione</option>
                                                <option value="40">Adjunto</option>
                                                <option value="46">Administrador(a)</option>
                                                <option value="1">Advogado</option>
                                                <option value="95">Agente de Contratação</option>
                                                <option value="41">Analista</option>
                                                <option value="61">Analista Fundiário</option>
                                                <option value="53">Analista judiciário</option>
                                                <option value="47">Arquiteto</option>
                                                <option value="91">Arquiteto e Urbanista</option>
                                                <option value="2">Assessor</option>
                                                <option value="87">Assessor Administrativo</option>
                                                <option value="3">Assessor Jurídico</option>
                                                <option value="4">Assistente</option>
                                                <option value="5">Assistente Jurídico</option>
                                                <option value="63">Assistente Social</option>
                                                <option value="6">Auditor</option>
                                                <option value="7">Auxiliar</option>
                                                <option value="8">Bibliotecário</option>
                                                <option value="86">Chefe de Departamento</option>
                                                <option value="90">Chefe de Gabinete</option>
                                                <option value="94">Chefe de Políticas Públicas Habitacionais</option>
                                                <option value="9">Chefe de Setor</option>
                                                <option value="85">Comercial</option>
                                                <option value="101">Compliance</option>
                                                <option value="11">Comprador</option>
                                                <option value="12">Comprador e Pregoeiro</option>
                                                <option value="97">Conselheiro</option>
                                                <option value="44">Contador</option>
                                                <option value="103">controlador</option>
                                                <option value="13">Coordenador</option>
                                                <option value="59">Corregedor</option>
                                                <option value="65">Desenhista e Projetista</option>
                                                <option value="92">Desenhista Projetista</option>
                                                <option value="14">Diretor</option>
                                                <option value="82">Diretor Jurídico</option>
                                                <option value="83">Diretor Planejamento</option>
                                                <option value="79">Diretor Presidente</option>
                                                <option value="69">Diretor Social</option>
                                                <option value="67">Diretor Técnico</option>
                                                <option value="16">Encarregado</option>
                                                <option value="17">Engenheiro</option>
                                                <option value="45">Engenheiro</option>
                                                <option value="71">Engenheiro Agrimensor</option>
                                                <option value="78">Engenheiro Civil</option>
                                                <option value="18">Fiscal de Contrato</option>
                                                <option value="73">Fiscal Fundiário</option>
                                                <option value="19">Gerente</option>
                                                <option value="93">Gerente de Projetos</option>
                                                <option value="80">Gerente de Regularização Fundiária</option>
                                                <option value="81">Gerente de Urbanismo</option>
                                                <option value="39">Gestor de Contratos</option>
                                                <option value="55">Membro da Comissão de PAD</option>
                                                <option value="21">Membro da CPL</option>
                                                <option value="48">Orçamentista de Obras</option>
                                                <option value="23">Ordenador de Despesas</option>
                                                <option value="43">Outro</option>
                                                <option value="42">Pesquisa de Preços</option>
                                                <option value="24">Prefeito</option>
                                                <option value="25">Pregoeiro</option>
                                                <option value="10">Pregoeiro e Chefe de Setor</option>
                                                <option value="15">Pregoeiro e Diretor</option>
                                                <option value="20">Pregoeiro e Gerente</option>
                                                <option value="22">Pregoeiro e Membro da CPL</option>
                                                <option value="28">Pregoeiro e Presidente da CPL</option>
                                                <option value="33">Pregoeiro e Responsável pela Licitação</option>
                                                <option value="26">Presidente</option>
                                                <option value="27">Presidente da CPL</option>
                                                <option value="29">Procurador</option>
                                                <option value="30">Pró-Reitor</option>
                                                <option value="31">Reitor</option>
                                                <option value="32">Responsável</option>
                                                <option value="99">Responsável planejamento</option>
                                                <option value="34">Secretário</option>
                                                <option value="35">Secretário de Governo</option>
                                                <option value="88">Secretário(a)</option>
                                                <option value="36">Superintendente</option>
                                                <option value="37">Supervisor</option>
                                                <option value="49">Técnico</option>
                                                <option value="51">Técnico judiciário</option>
                                                <option value="57">Tesoureiro</option>
                                                <option value="75">Topógrafo</option>
                                                <option value="89">Urbanista</option>
                                                <option value="38">Vice-Prefeito</option>
                                                <option value="84">Vice-Presidente</option>
                                            </select>
                                        </div>
                                        <div class="col-lg-4">
                                            <label for="convenio" class="pt-3 pb-1 font-1">UF de Atuação *</label>
                                            <select class="form-control informacao form-select" v-model="participante_crud.nmUf">
                                                <option value="">Selecione</option>
                                                <option value="AC">Acre</option>
                                                <option value="AL">Alagoas</option>
                                                <option value="AM">Amazonas</option>
                                                <option value="AP">Amapá</option>
                                                <option value="BA">Bahia</option>
                                                <option value="CE">Ceará</option>
                                                <option value="DF">Distrito Federal</option>
                                                <option value="ES">Espírito Santo</option>
                                                <option value="GO">Goiás</option>
                                                <option value="MA">Maranhão</option>
                                                <option value="MT">Mato Grosso</option>
                                                <option value="MS">Mato Grosso do Sul</option>
                                                <option value="MG">Minas Gerais</option>
                                                <option value="PA">Pará</option>
                                                <option value="PB">Paraíba</option>
                                                <option value="PR">Paraná</option>
                                                <option value="PE">Pernambuco</option>
                                                <option value="PI">Piauí</option>
                                                <option value="RJ">Rio de Janeiro</option>
                                                <option value="RN">Rio Grande do Norte</option>
                                                <option value="RO">Rondônia</option>
                                                <option value="RS">Rio Grande do Sul</option>
                                                <option value="RR">Roraima</option>
                                                <option value="SC">Santa Catarina</option>
                                                <option value="SE">Sergipe</option>
                                                <option value="SP">São Paulo</option>
                                                <option value="TO">Tocantins</option>
                                            </select>
                                            <span class="labelValidacao field-validation-valid"></span>
                                        </div>
                                        <div class="col-6">
                                            <input @click="animate" class="form-check-input input-checkbox ms-5" type="checkbox" name="input_checkbox" id="r_alimentar" value="r_alimentar">
                                            <label class="form-check-label font-7 ms-1" for="r_alimentar">
                                                Restriçâo Alimentar
                                            </label>
                                            <div class="col restricoes" v-show="restricao_alimentar_check">
                                                <div class="mt-2" v-for="opcao in lst_restricoes.opcoes" :key="opcao.idTipoAlimentacao">
                                                    <input class="form-check-input ms-5" type="checkbox" name="input_checkbox" :id="'check_' + opcao.idTipoAlimentacao" :value="opcao.idTipoAlimentacao" v-model="opcao.checked_box">
                                                    <label class="form-check-label font-7 mt-0 ms-1" for="vegetariano">
                                                        {{ opcao.nmAlimentacao }}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <input @click="animate2" class="form-check-input input-checkbox ms-3" type="checkbox" name="input_checkbox" id="p_deficiencia" value="p_deficiencia">
                                            <label class="form-check-label font-7 ms-1" for="p_deficiencia">
                                                Pessoa com Deficiência
                                            </label>
                                            <select v-show="deficiencia_check" v-model="participante_crud.idTipoDeficiencia" class="form-control mt-2" id="q_deficiencia">
                                                <option value="">Selecione</option>
                                                <option value="3">Cadeirante</option>
                                                <option value="4">Deficiência Física</option>
                                                <option value="2">Deficiente Auditivo</option>
                                                <option value="1">Deficiente Visual</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-2">
                                <div class="col-sm-12 col-lg-12">
                                    <button class="btn btn-success float-end rounded" id="salvar" v-on:click="confirmar_participante">SALVAR PARTICIPANTE</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card painel-3">
                        <div class="card-body card-body3" v-for="participante in participantes" :key="participante.idParticipante">
                            <div class="row">
                                <div class="col-lg-12 pt-1">
                                    <h3 class="pb-1 font-9">
                                        Passaporte:
                                        <span class="font-8">{{ participante.cdPassaporte }}</span>
                                    </h3>
                                </div>
                                <div class="col-sm-12 col-lg-9">
                                    <label class="pb-1 pt-2 font-1">Email</label>
                                    <p class="paragrafo-3">{{ participante.dsEmail }}</p>
                                </div>
                                <div class="col-sm-12 col-lg-3">
                                    <label class="pb-1 pt-2 font-1">Sexo</label>
                                    <p class="paragrafo-3">{{ participante.tpSexo }}</p>
                                </div>
                                <div class="col-sm-12 col-lg-6">
                                    <label class="pb-1 pt-2 font-1">Nome Completo</label>
                                    <p class="paragrafo-3">{{ participante.nmParticipante }}</p>
                                </div>
                                <div class="col-sm-12 col-lg-6">
                                    <label class="pb-1 pt-2 font-1">Nome Crachá</label>
                                    <p class="paragrafo-3">{{ participante.nmApelido }}</p>
                                </div>
                                <div class="col-sm-12 col-lg-3">
                                    <label class="pb-1 pt-2 font-1">Cpf</label>
                                    <p class="paragrafo-3">{{ participante.nrCpf }}</p>
                                </div>
                                <div class="col-sm-12 col-lg-3">
                                    <label class="pb-1 pt-2 font-1">Rg</label>
                                    <p class="paragrafo-3">{{ participante.nrRg }}</p>
                                </div>
                                <div class="col-sm-12 col-lg-3">
                                    <label class="pb-1 pt-2 font-1">Celular</label>
                                    <p class="paragrafo-3">{{ participante.nrCelular }}</p>
                                </div>
                                <div class="col-sm-12 col-lg-3">
                                    <label class="pb-1 pt-2 font-1">Data de Nascimento</label>
                                    <p class="paragrafo-3">{{ participante.dtNascimento }}</p>
                                </div>
                                <div class="col-sm-12 col-lg-3">
                                    <label class="pb-1 pt-2 font-1">Departamento</label>
                                    <p class="paragrafo-3">{{ participante.idDepartamento }}</p>
                                </div>
                                <div class="col-sm-12 col-lg-3">
                                    <label class="pb-1 pt-2 font-1">Função</label>
                                    <p class="paragrafo-3">{{ participante.idFuncao }}</p>
                                </div>
                                <div class="col-sm-12 col-lg-3">
                                    <label class="pb-1 pt-2 font-1">UF de Atuação</label>
                                    <p class="paragrafo-3">{{ participante.nmUf }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    //import $ from "jquery";
    import moment from "moment";
    import $ from "jquery";
    import axios from "axios";

    export default {
        name: "Inscricao",
        components: {

        },
        data() {
            return {
                evento: {},
                inscricao: {},
                autenticar: false,
                acesso: { idEvento: 0, dsEmailResponsavel: '', cdLocalizador: '', nrPin: '', flLiberaPin: false },
                participantes: [],
                participante_crud: {
                    nmApelido: '', dsEmailConfirma: '', idDepartamento: 0, idFuncao: 0, tpSexo: '', nmUf: '', idTipoDeficiencia: 0,
                },
                restricao_alimentar_check: false,
                deficiencia_check: false,
                lst_restricoes: {
                    opcoes: [
                        { idTipoAlimentacao: 1, nmAlimentacao: 'Vegetariano', checked_box: false },
                        { idTipoAlimentacao: 2, nmAlimentacao: 'Vegano', checked_box: false },
                        { idTipoAlimentacao: 3, nmAlimentacao: 'Intolerância à Lactose', checked_box: false },
                        { idTipoAlimentacao: 4, nmAlimentacao: 'Intolerância à Glúten', checked_box: false },
                        { idTipoAlimentacao: 5, nmAlimentacao: 'Celíaco', checked_box: false },
                        { idTipoAlimentacao: 6, nmAlimentacao: 'Alérgico', checked_box: false }
                    ]
                },
            }
        },
        methods: {
            imprimir_inscricao() {
                const url = 'https://gnp.negociospublicos.net.br/NP/Eventos/Inscricao/GeraArquivoInscricao/?p_idInscricao=' + this.inscricao.idInscricao + '&p_idParticipante=0';
                window.open(url, '_blank');
            },
            confirmar_pin() {
                let $this = this;
                axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/ConfirmarAcessoInscricao', $this.acesso, { headers: null })
                    .then(function (response) {
                        var storage = { ok: 'ok' };
                        var storageString = JSON.stringify(storage);
                        var cdLocalizador = String($this.inscricao.cdLocalizador).trim();
                        var idEvento = String($this.evento.idEvento).trim();
                        var storageKey = cdLocalizador + '_' + idEvento;
                        localStorage.setItem(storageKey, storageString);

                        $this.autenticar = false;
                        $this.acesso.flLiberaPin = false;
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    });
            },
            solicitar_acesso() {
                let $this = this;

                $this.acesso.dsEmailResponsavel = $this.acesso.dsEmailResponsavel.toLowerCase();

                axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/SolicitarAcessoInscricao', $this.acesso, { headers: null })
                    .then(function (response) {
                        $this.acesso.flLiberaPin = true;
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    });

            },
            formatDay(date) {
                return moment(date).format('DD');
            },
            formatMonth(date) {
                return moment(date).format('MMM').toUpperCase();
            },
            formatYear(date) {
                return moment(date).format('YYYY');
            },
            GetDadosEvento(_idEvento, _cdLocalizador) {
                let $this = this;
                var idEvento = (_idEvento / 1000);
                axios.get(process.env.VUE_APP_ROOT_EVENTOS_API + '/Evento/GetDadosEventoExterno?idEvento=' + idEvento, {
                    headers: null,
                    notLoading: true
                }).then(response => {
                    $this.evento = response.data.data;
                    $this.acesso.idEvento = $this.evento.idEvento;
                    $this.GetDadosInscricao(_cdLocalizador);
                }).catch(error => {
                    window.location.href = 'https://negociospublicos.com.br';
                });
            },
            GetDadosInscricao(_cdLocalizador) {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/GetDadosInscricaoExterno/' + _cdLocalizador, {
                    headers: null,
                    notLoading: true
                }).then(response => {
                    $this.inscricao = response.data.data;
                    $this.acesso.cdLocalizador = $this.inscricao.cdLocalizador;
                    var storage = JSON.parse(localStorage.getItem(_cdLocalizador + '_' + $this.evento.idEvento));
                    if ($this.inscricao.idEvento != $this.evento.idEvento) {
                        window.location.href = 'https://negociospublicos.com.br';
                    }
                    else if (storage == null) {
                        $this.autenticar = true;
                    } else {
                        $this.GetDadosParticipantes();
                    }
                }).catch(error => {
                    window.location.href = 'https://negociospublicos.com.br';
                });
            },
            GetDadosParticipantes() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_EVENTOS_API + '/Participante/GetParticipantesExterno/' + $this.inscricao.idInscricao, {
                    headers: null,
                    notLoading: true
                }).then(response => {
                    $this.participantes = response.data.data;
                }).catch(error => { });
            },
            confirmar_participante() {
                let $this = this;

                if ($this.participante_crud.dsEmail == '' || $this.participante_crud.dsEmail == null) {
                    $this.$toast.show('alert', 'O e-mail é um campo obrigatório. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if ($this.participante_crud.dsEmailConfirma == '' || $this.participante_crud.dsEmailConfirma == null) {
                    $this.$toast.show('alert', 'A confirmação de e-mail é um campo obrigatório. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if ($this.participante_crud.nmApelido == '' || $this.participante_crud.nmApelido == null) {
                    $this.$toast.show('alert', 'O nome é um campo obrigatório. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if ($this.participante_crud.nmUf == '' || $this.participante_crud.nmUf == null) {
                    $this.$toast.show('alert', 'UF de atuação é um campo obrigatório. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if ($this.participante_crud.idDepartamento == '' || $this.participante_crud.idDepartamento == null) {
                    $this.$toast.show('alert', 'O departamento é um campo obrigatório. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if ($this.participante_crud.idFuncao == '' || $this.participante_crud.idFuncao == null) {
                    $this.$toast.show('alert', 'A função é um campo obrigatório. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if ($this.participante_crud.tpSexo == '' || $this.participante_crud.tpSexo == null) {
                    $this.$toast.show('alert', 'O sexo é um campo obrigatório. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if ($this.participante_crud.nrCpf == '' || $this.participante_crud.nrCpf == null) {
                    $this.$toast.show('alert', 'O cpf é um campo obrigatório. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if ($this.participante_crud.nmParticipante == '' || $this.participante_crud.nmParticipante == null) {
                    $this.$toast.show('alert', 'O nome completo é um campo obrigatório. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if (!$this.$phoneValidator.validatePhoneCell('', $this.participante_crud.nrCelular)) {
                    $this.$toast.show('alert', 'Telefone ou celular é obrigatório e deve estar completo!', true);
                    return;
                }                

                if ($this.participante_crud.dtNascimento == '' || $this.participante_crud.dtNascimento == null) {
                    $this.$toast.show('alert', 'O data de nascimento é um campo obrigatório. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if ($this.participante_crud.dsEmail != $this.participante_crud.dsEmailConfirma) {
                    $this.$toast.show('alert', 'Os e-mails inseridos não coincidem. Por favor, verifique e tente novamente.', true);
                    return;
                }

                if ($this.restricao_alimentar_check) {
                    $this.participante_crud.lstRestricaoAlimentar = $this.lst_restricoes.opcoes;
                }

                $this.participante_crud.idEvento = $this.evento.idEvento;
                $this.participante_crud.idInscricao = $this.inscricao.idInscricao;

                $this.participante_crud.dsEmail = $this.participante_crud.dsEmail.toLowerCase();
                $this.participante_crud.dsEmailConfirma = $this.participante_crud.dsEmailConfirma.toLowerCase();

                axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Participante/PostParticipanteExterno', $this.participante_crud, { headers: null })
                    .then(function (response) {
                        location.reload();
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.$toast.show('alert', msg, true);
                    });
            },
            animate() {
                this.restricao_alimentar_check = !this.restricao_alimentar_check;
            },
            animate2() {
                this.deficiencia_check = !this.deficiencia_check;
            }
        },
        mounted() {
            var urlParams = new URLSearchParams(window.location.search);
            var idEvento = urlParams.get('evento');
            var localizador = urlParams.get('localizador');
            this.GetDadosEvento(idEvento, localizador);
        },
        updated() { },
        watch: {
            restricao_alimentar_check(NovoChecked, Antigochecked) {
                if (NovoChecked === false) {
                    this.lst_restricoes.opcoes.forEach((opcao) => {
                        opcao.checked_box = false;
                    });
                }
            },
            deficiencia_check(NovoChecked, Antigochecked) {
                if (NovoChecked === false) {
                    this.participante_crud.idTipoDeficiencia = 0;
                }
            }
        },
    };

</script>

<style scoped lang="scss">

    .container-formulario {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: calc(100vh - 0rem);
        height: calc(100vh - 0rem);
        background-color: #f8f8f8;
        padding: 0;
    }

    .painel {
        margin-top: 15px;
        margin-left: 30px;
        margin-right: 30px;
    }

    @media(min-width:340px) {
        .painel {
            margin-top: 15px;
            margin-left: 80px;
            margin-right: 50px;
        }
    }

    @media(min-width:992px) {
        .painel {
            margin-left: 40px;
            width: 200px;
            margin-right: 10px;
        }
    }

    @media(min-width:1200px) {
        .painel {
            margin-left: 40px;
            width: 220px;
            margin-right: 10px;
        }
    }

    @media(min-width:1350px) {
        .painel {
            margin-left: 40px;
            width: 250px;
            margin-right: 10px;
        }
    }

    .conteudo {
        padding-left: 30px;
        padding-right: 40px;
    }

    @media(min-width:992px) {
        .conteudo {
            padding-left: 10px;
            margin-left: 30px;
        }
    }

    @media(min-width:1000px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 30px;
        }
    }

    .linha-1 {
        border: 1px solid #d3d3d3;
        background-color: #fff;
        margin-left: 2px;
        margin-right: 2px;
        min-height: calc(100vh);
        border-top: none;
        border-bottom: none;
    }

    @media (min-width: 430px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 32px;
            margin-right: 32px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 550px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 52px;
            margin-right: 32px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 600px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 100px;
            margin-right: 70px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 992px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: calc(10vw - 30px) !important;
            margin-right: calc(10vw - 30px) !important;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1200px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1400px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1500px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1600px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1800px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    .row > * {
        flex-shrink: 1;
    }

    .titulo {
        font-size: 14px;
        color: #bd2344;
        font-weight: 700
    }

    .titulo2 {
        font-size: 21px;
        line-height: 26px;
        color: #7a7a7a;
        margin-top: 5px;
        margin-bottom: 15px;
    }

    .texto-1 {
        font-size: 15px;
        line-height: 20px;
        color: #7a7a7a;
        margin-top: 5px;
    }

    .texto-2 {
        font-size: 15px;
        line-height: 20px;
        color: #7a7a7a;
    }

    .painel-2 {
        margin-top: 10px;
        margin-left: 30px;
        margin-right: 30px;
        padding: 16px;
        margin-bottom: 30px;
        height: 810px;
    }

    @media(min-width:340px) {
        .painel-2 {
            margin-top: 10px;
            margin-left: 80px;
            margin-right: 50px;
            padding: 16px;
            margin-bottom: 30px;
        }
    }

    @media(min-width:992px) {
        .painel-2 {
            margin-top: 30px;
            margin-left: 40px;
            width: 200px;
            margin-right: 10px;
        }
    }

    @media(min-width:1200px) {
        .painel-2 {
            margin-top: 30px;
            margin-left: 40px;
            margin-right: 10px;
            width: 220px;
        }
    }

    @media(min-width:1350px) {
        .painel-2 {
            margin-left: 40px;
            width: 250px;
            margin-right: 10px;
        }
    }

    .painel-3 {
        display: block;
        margin-top: 30px;
    }

    .btn-pagination {
        padding: 15px;
        border: none;
    }

    @media(min-width:992px) {
        .btn-pagination {
            padding: 15px;
        }
    }

    .btn-pagination2 {
        padding: 15px;
        border: none;
    }

    @media(min-width:992px) {
        .btn-pgnt2 {
            height: 0;
        }
    }

    .card-painel {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
    }

    @media(min-width:630px) {
        .card-painel {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel {
            visibility: hidden;
            margin: 0;
            height: 0;
        }
    }

    .card-body2 {
        padding-bottom: 0;
        padding-left: 12px;
        padding-right: 12px;
    }

    .card-body3 {
        background-color: #f5f5f5;
    }

    .card-painel2 {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 16px;
    }

    @media(min-width:630px) {
        .card-painel2 {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel2 {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel2 {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel2 {
            visibility: hidden;
            margin: 0;
            padding: 0;
            height: 300px;
            display: block;
        }
    }

    .card-painel3 {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 16px;
    }

    @media(min-width:630px) {
        .card-painel3 {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel3 {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel3 {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel3 {
            visibility: hidden;
            margin: 0;
            padding: 0;
            height: 0;
            display: block;
        }
    }

    .active > .page-link,
    .page-link.active {
        margin-right: 15px !important;
        border-color: #ba2743 !important;
        color: #fff !important;
        background: #ba2743 !important;
        width: 37px !important;
        height: 39px !important;
        text-align: center !important;
        padding-top: 6px !important;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none !important;
        outline-style: none !important;
        z-index: 99 !important;
        margin-left: 10px !important;
        padding-bottom: 10px !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        font-size: 16px !important;
    }


    .formularios {
        font-size: 22px;
        color: #bd2344;
        border-bottom: 1px solid #d3d3d3;
        padding-bottom: 10px;
        display: block;
    }

    .dados-instituicao {
        font-size: 18px;
        color: #bd2344;
        font-weight: 500;
        border-bottom: 1px solid#ececec;
        padding-bottom: 13px;
    }

    .logo {
        height: 34px;
        margin-bottom: 0px;
        margin-left: 10px;
        margin-right: 10px;
        float: right;
    }

    @media(max-width:991px) {
        .logo {
            visibility: hidden;
            height: 0;
            width: 0;
        }
    }

    @media(min-width:992px) {
        .logo {
            height: 34px;
            margin-right: 30px;
            margin-left: 10px;
            float: right;
        }
    }

    @media(min-width:1200px) {
        .logo {
            height: 34px;
            margin-right: 30px;
            margin-left: 10px;
            float: right;
        }
    }

    @media(min-width:1400px) {
        .logo {
            margin-right: 34px;
            float: right;
            height: 34px;
        }
    }

    @media(min-width:1537px) {
        .logo {
            margin-right: 34px;
            float: right;
            height: 34px;
        }
    }

    @media(min-width:1800px) {
        .logo {
            margin-right: 20px;
            float: right;
            height: 34px;
        }
    }

    .evento {
        margin-top: 30px;
        height: 130px;
        width: 150px;
        margin-bottom: 0px;
        margin-right: 30px;
        margin-left: 30px;
    }

    @media(min-width:220px) {
        .evento {
            margin-top: 30px;
            height: 130px;
            width: 180px;
            margin-bottom: 0px;
            margin-right: 30px;
            margin-left: 30px;
        }
    }

    @media(min-width:250px) {
        .evento {
            margin-top: 30px;
            height: 130px;
            width: 230px;
            margin-bottom: 0px;
            margin-right: 30px;
            margin-left: 30px;
        }
    }

    @media(min-width:300px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 650px;
            margin-bottom: 0px;
            margin-right: 30px;
            margin-left: 30px;
        }
    }

    @media(min-width:340px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 650px;
            margin-bottom: 0px;
            margin-right: 50px;
            margin-left: 80px;
        }
    }

    @media(min-width:520px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 650px;
            margin-bottom: 0px;
            margin-right: 50px;
            margin-left: 80px;
        }
    }

    @media(min-width:700px) {
        .evento {
            margin-top: 30px;
            height: 280px;
            width: 650px;
            margin-bottom: 0px;
            margin-right: 50px;
            margin-left: 80px;
        }
    }

    @media(min-width:992px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 200px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    @media(min-width:1200px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 220px !important;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    @media(min-width:1350px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 250px !important;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    .descritivo {
        color: #777;
    }

    .informacao {
        border-color: #bbbbbb;
        margin-right: 1px;
        font-size: 14px;
    }

    .informacao2 {
        border-color: #bbbbbb;
        font-size: 14px;
    }

    .btn-danger {
        background-color: #bd2344;
        color: #fff;
        margin-top: 20px;
        font-size: 15px;
        font-weight: 700;
        padding: 10px 20px;
        border-radius: 0;
        border: 2px solid #ececec;
    }

    .icon-inscricao {
        padding-right: 5px;
        font-size: 15px;
    }

    .btn-inscricao {
        background-color: #bd2344;
        color: #fff;
        font-size: 15px;
        font-weight: 400;
        padding: 3px 5px;
        border-radius: 0;
        border: 2px solid #ececec;
    }

    @media(min-width:992px) {
        .btn-inscricao {
            background-color: #bd2344;
            color: #fff;
            font-size: 15px;
            font-weight: 400;
            padding: 3px 5px;
            border-radius: 0;
            border: 2px solid #ececec;
        }
    }

    #salvar {
        color: #fff;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 15px;
        font-weight: 500;
        padding: 10px 20px;
        border-radius: 0;
        border: 2px solid #ececec;
        margin-right: 20px;
    }

    .btn-success {
        background-color: #158000;
        color: #fff;
        margin-top: 20px;
        font-size: 15px;
        padding: 10px 20px;
        font-weight: 500;
    }

    .footer {
        border-top: 1px solid #ececec;
        margin-top: 30px;
        border-color: #ddd;
    }

    .footer-2 {
        margin-top: 30px;
        border-color: #ddd;
        display: block;
    }

    @media(min-width:992px) {
        .footer-2 {
            margin-top: 30px;
            border-color: #ddd;
           /* height: 1030px;*/
            display: flex;
        }
    }

    @media(min-width:1400px) {
        .footer-2 {
            margin-top: 30px;
            border-color: #ddd;
           /* height: 1030px;*/
            display: flex;
        }
    }

    @media(min-width:1500px) {
        .footer-2 {
            margin-top: 30px;
            border-color: #ddd;
           /* height: 1050px;*/
            display: flex;
        }
    }

    .linha-2 {
        margin-left: 0px;
        margin-right: 0px;
        margin-top: 0;
        padding: 10px;
        background-color: #f5f5f5;
        border-color: #ddd;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        display: block;
    }

    .font-1 {
        font-weight: 600;
        font-size: 14px;
        color: #4c4c4c;
    }

    .font-2 {
        font-weight: 600;
        font-size: 14px;
        color: #575757;
        padding-left: 10px;
    }

    .font-3 {
        font-size: 13px;
        margin-bottom: 10px;
        padding-left: 10px;
    }


    @media(min-width:992px) {
        .font-3 {
            font-size: 13px;
            margin-bottom: 3px;
            padding-left: 10px;
        }
    }

    .font-4 {
        font-weight: 700;
        font-size: 16px;
        color: #4c4c4c;
    }

    .font-5 {
        font-weight: 700;
        font-size: 16px;
        color: #4c4c4c;
    }

    .font-6 {
        font-weight: 400;
        color: #707070;
    }

    .font-7 {
        font-weight: 400;
        font-size: 16px;
        color: #4c4c4c;
        margin-top: 20px;
    }

    .font-8 {
        font-size: 30px;
        color: #bd2344;
        padding-bottom: 10px;
        font-weight: 500;
    }

    .font-9 {
        font-size: 18px;
        color: #bd2344;
        border-bottom: 1px solid #d3d3d3;
        padding-bottom: 10px;
        display: block;
    }

    .input-checkbox {
        margin-top: 23px;
    }

    .btn-secondary {
        background-color: #d8d8d8;
        color: #575757;
        margin-top: 20px;
        font-size: 15px;
        font-weight: 700;
        border: #bbbbbb;
        padding: 10px 20px;
        border-radius: 0;
    }

    .btn-secondary:hover {
        background-color: #d8d8d8;
        color: #575757;
    }

    .btn-link {
        border: 2px solid #f5f5f5;
        background: #f5f5f5;
        width: 37px;
        height: 39px;
        text-align: center;
        padding-top: 5px;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none;
        outline-style: none;
        z-index: 99;
        color: #bbb;
        background: #f5f5f5;
        margin-right: 15px;
        padding-bottom: 10px;
        padding-left: 0;
        padding-right: 0;
        font-size: 16px;
    }

    .btn-link-4 {
        border: 2px solid #f5f5f5;
        background: #f5f5f5;
        width: 43px;
        height: 45px;
        text-align: center;
        padding: 5px 0;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none;
        outline-style: none;
        z-index: 99;
        color: #bbb;
        background: #f5f5f5;
    }

    .cardbody {
        padding: 0;
    }

    .btn-pgnt {
        margin-bottom: 0;
    }

    .btn-pgnt2 {
        margin-bottom: 0;
    }

    @media(min-width:992px) {
        .btn-pgnt2 {
            height: 0;
        }
    }

    .container-2 {
        margin-left: 0;
        margin-top: 0;
    }

    .quantidade-participantes {
        border-color: #7a7a7a;
        font-size: 40px;
        box-shadow: 1px solid !important;
        color: #555 !important;
        font-weight: 600;
    }

    @media(min-width:992px) {
        .quantidade-participantes {
            border-color: #a8a8a8;
            margin-left: 90px;
            font-size: 40px;
        }
    }


    .m-quantidade-participantes {
        padding-top: 60px;
        padding-bottom: 40px;
    }

    #q-participantes {
        color: #4c4c4c;
        font-size: 20px;
        padding-left: 10px;
        font-weight: 600;
    }

    @media(min-width:992px) {
        #q-participantes {
            color: #4c4c4c;
            font-size: 20px;
            padding-left: 15px;
            font-weight: 600;
            margin-left: 95px;
        }
    }

    .paragrafo-1 {
        font-size: 16px;
        color: #96102d;
        padding-right: 40px;
        padding-left: 45px;
        font-weight: 400;
    }

    @media(min-width:992px) {
        .paragrafo-1 {
            font-size: 16px;
            padding-left: 0;
            padding-right: 0;
            margin-bottom: 0;
        }
    }

    .paragrafo-2 {
        font-size: 16px;
        color: #96102d;
        padding-left: 45px;
        padding-right: 40px;
        font-weight: 400;
    }

    @media(min-width:992px) {
        .paragrafo-2 {
            font-size: 16px;
            padding-right: 0;
            padding-left: 0;
        }
    }


    .paragrafo-3 {
        font-size: 14px
    }

    .corpo-col {
        padding-right: 0;
        margin-left: 10px;
    }

    @media(min-width:992px) {
        .corpo-col {
            margin-left: 130px;
            padding-right: 40px;
        }
    }

    .paragrafo-danger {
        font-size: 26px;
        text-align: center;
        color: #333;
        font-weight: 500;
    }
</style>